import React from "react";
import "../App.css";
import GameScreen3 from "../assets/Screen/Screen3.png";
import GameScreen2 from "../assets/Screen/Screen2.png";
import GameScreen1 from "../assets/Screen/Screen1.png";

// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

const Fightsystem = ({ t }) => {
  const copy = t.fightSystem;

  return (
      <Swiper
          className="fight-swiper"
          spaceBetween={50}
          slidesPerView={1}
          loop
          loopAdditionalSlides={1}
          navigation
          pagination={{ clickable: true, dynamicBullets: true }}
          scrollbar={{ draggable: true }}
          grabCursor
      >
        <SwiperSlide>
          <div className="i">
            <div className="about-project">
              <h1>{copy.slides[0].title}</h1>
              <div className="hud-subtitle">{copy.slides[0].subtitle}</div>
              <div className="hud-card">
                <div className="hud-text">{copy.slides[0].text}</div>
              </div>
            </div>

            <div className="i-right">
              <div className="video-frame">
                <iframe
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                    src="https://www.youtube.com/embed/xfssFyLa7dc?rel=0&modestbranding=1"
                    title={copy.videoTitle}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="i">
            <div className="i-left">
              <img className="screen" src={GameScreen1} alt={copy.screen1Alt} />
            </div>

            <div className="about-project">
              <h1>{copy.slides[1].title}</h1>
              <div className="hud-subtitle">{copy.slides[1].subtitle}</div>
              <div className="hud-card">
                <div className="hud-text">{copy.slides[1].text}</div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="i">
            <div className="about-project">
              <h1>{copy.slides[2].title}</h1>
              <div className="hud-subtitle">{copy.slides[2].subtitle}</div>
              <div className="hud-card">
                <div className="hud-text">{copy.slides[2].text}</div>
              </div>
            </div>

            <div className="i-right">
              <img className="screen" src={GameScreen3} alt={copy.screen3Alt} />
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="i">
            <div className="i-left">
              <img className="screen" src={GameScreen2} alt={copy.screen2Alt} />
            </div>

            <div className="about-project">
              <h1>{copy.slides[3].title}</h1>
              <div className="hud-subtitle">{copy.slides[3].subtitle}</div>
              <div className="hud-card">
                <div className="hud-text">{copy.slides[3].text}</div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
  );
};

export default Fightsystem;
